// extracted by mini-css-extract-plugin
module.exports = {"InfoIcon":"IconButtons_InfoIcon__1NvvN"};